module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPBAMAAAAfXVIcAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBQTFRFAAAA////////////////////////////////////////////////////////////O00EMAAAABB0Uk5TACIRVe7dRP+Id8yqmbszZsZWAMcAAAB+SURBVHicY2BUYGBgMhZgYFAJYmBIKa9gYOAsVWAu6Vw+gYFhelC6G4OKA0goK4GBu5ABJMTAwFrAwMDcWarAsP0AA4O50/Qg7loGBraSBM7SJ5eAsmVAVXFAU9UvMDBYlkIY3PUgjbz1TNsvAY1nYHR3r1UAmyUTBbSHswEAZeMdyfd/mX8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_disconnect.png
// module id = 1F+P
// module chunks = 0